import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAdgbLAL_jdLUtbuuZ_pIGfsFWw0RxoVoo',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'zelwebsite-5e626.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'zelwebsite-5e626',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'zelwebsite-5e626.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '171785137638',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:171785137638:web:35e77fed72ab02076c3a27',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-NLCLPDDGF3',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Analytics only loads in browser environments that support it (skip during SSR/tests).
analyticsSupported().then((ok) => {
  if (ok) getAnalytics(app);
}).catch(() => {});

export default app;
